import React from "react";

import { atom, useAtom } from "jotai";
import { BrowserRouter as Router } from "react-router-dom";
import ProtectedApp from "./utils/protectedApp";
import "primereact/resources/themes/bootstrap4-light-blue/theme.css"; // theme
import "primeflex/primeflex.css"; // css utility
import "primeicons/primeicons.css";
import "primereact/resources/primereact.css";
import { BlockUI } from "primereact/blockui";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import { loadingState } from "./states/loadingState";

import ToastGlobal from "./components/toastGlobal";

const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY;

const App = () => {
  const [isLoading] = useAtom(loadingState);

   return (
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY}>
      <Router>
        <ToastGlobal />
        <BlockUI blocked={isLoading} fullScreen>
          <ProtectedApp />
        </BlockUI>
      </Router>
    </GoogleReCaptchaProvider>
  );
};

export default App;
